<template>
    <div class="website mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="website != '' ? 'border-primary' : ''" type="text" id="inputWebsite"
                v-model="website" @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': website != ''
                }">Thêm link website của bạn</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            website: ''
        }
    },
    watch: {
        data(val){
            this.website = val;
        },
        website(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.website = this.data;
    }
}
</script>
